import React, { useState, useEffect, useCallback } from 'react';
import PanelLayout from '../Panel/PanelLayout';
import { bpAPI } from '../../services/api';

const C = { surface: '#FFFFFF', border: '#e8e8f1', borderSoft: '#f0f0f6', ink: '#14142b', muted: '#6e6e86', primary: '#7c3aed', success: '#10B981', warning: '#F59E0B', danger: '#EF4444', radius: 14, radiusSm: 8 };

const StatusBadge = ({ status }) => {
  const map = {
    completed: { bg: '#D1FAE5', color: '#059669' },
    pending:   { bg: '#FEF3C7', color: '#D97706' },
    failed:    { bg: '#FEE2E2', color: '#DC2626' },
    processing:{ bg: '#ddd6fe', color: '#7c3aed' },
  };
  const s = map[status] || map.pending;
  return (
    <span style={{ background: s.bg, color: s.color, fontSize: 11, fontWeight: 700, padding: '2px 10px', borderRadius: 20 }}>
      {status}
    </span>
  );
};

const BPSettlements = () => {
  const [settlements, setSettlements] = useState([]);
  const [meta, setMeta]               = useState({});
  const [loading, setLoading]         = useState(true);
  const [status, setStatus]           = useState('');

  const load = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await bpAPI.settlements({ status, page });
      setSettlements(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch {}
    finally { setLoading(false); }
  }, [status]);

  useEffect(() => { load(); }, [load]);

  return (
    <PanelLayout role="business_partner" title="Settlements" breadcrumb="Dashboard / Settlements">
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 14 }}>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: C.ink, letterSpacing: '-.02em' }}>Settlements</h1>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: C.muted }}>Track settlement payouts from your referred merchants.</p>
          </div>
          <div style={{ background: C.surface, border: `1.5px solid ${C.border}`, borderRadius: C.radius, display: 'flex', alignItems: 'center', padding: '0 12px', gap: 4, overflow: 'hidden' }}>
            {[{ label: 'All', val: '', color: C.primary }, { label: 'Pending', val: 'pending', color: C.warning }, { label: 'Processing', val: 'processing', color: C.primary }, { label: 'Completed', val: 'completed', color: C.success }, { label: 'Failed', val: 'failed', color: C.danger }].map(t => (
              <button key={t.val} onClick={() => setStatus(t.val)} style={{ height: 42, padding: '0 14px', borderRadius: 999, border: `1.5px solid ${status === t.val ? t.color : 'transparent'}`, background: status === t.val ? t.color : 'transparent', color: status === t.val ? '#fff' : C.muted, fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', fontFamily: 'inherit', transition: 'all .15s' }}>{t.label}</button>
            ))}
          </div>
        </div>

        <div style={{ border: '1px solid #e8e8f1', borderRadius: 14, overflow: 'hidden' }}>
          <div style={{
            display: 'grid', gridTemplateColumns: '1.5fr 1.2fr 120px 110px 130px',
            background: '#f9f9fc', padding: '10px 16px',
            fontSize: 10, fontWeight: 700, color: '#4a4a6a', letterSpacing: 1, textTransform: 'uppercase',
          }}>
            <span>Settlement ID</span><span>Merchant</span><span>Amount</span><span>Status</span><span>Date</span>
          </div>

          {loading && <div style={{ textAlign: 'center', padding: 60, color: '#6e6e86' }}>Loading…</div>}

          {!loading && settlements.length === 0 && (
            <div style={{ textAlign: 'center', padding: 60, color: '#6e6e86', fontSize: 13 }}>
              No settlements found.
            </div>
          )}

          {!loading && settlements.map((s, i) => (
            <div key={s.id} style={{
              display: 'grid', gridTemplateColumns: '1.5fr 1.2fr 120px 110px 130px',
              padding: '13px 16px', alignItems: 'center',
              borderTop: '1px solid #f0f0f6',
              background: i % 2 === 0 ? '#fff' : '#FAFAFA',
            }}>
              <div style={{ fontFamily: 'monospace', fontSize: 12, color: '#14142b', fontWeight: 600 }}>
                {s.settlement_id || `#${s.id}`}
              </div>
              <div style={{ fontSize: 12, color: '#4a4a6a' }}>{s.merchant?.username || '—'}</div>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#14142b' }}>
                ₹{Number(s.amount || 0).toLocaleString('en-IN')}
              </div>
              <StatusBadge status={s.status} />
              <div style={{ fontSize: 12, color: '#6e6e86' }}>
                {s.created_at ? new Date(s.created_at).toLocaleDateString('en-IN') : '—'}
              </div>
            </div>
          ))}
        </div>

        {meta.last_page > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
            {Array.from({ length: meta.last_page }, (_, i) => i + 1).map(page => (
              <button
                key={page}
                onClick={() => load(page)}
                style={{
                  width: 36, height: 36, borderRadius: 8, border: '1px solid #e8e8f1',
                  background: page === meta.current_page ? '#14142b' : '#fff',
                  color: page === meta.current_page ? '#fff' : '#14142b',
                  fontSize: 13, fontWeight: 600, cursor: 'pointer',
                }}
              >{page}</button>
            ))}
          </div>
        )}
      </div>
    </PanelLayout>
  );
};

export default BPSettlements;
